<template>
  <div class="Boyo-button"
       style="margin-bottom:10px">
    <div class="left">
      <div v-for="(item,index) of buttonList.left"
           :key="index"
           style="display:inline-block">
        <el-button v-if="item.event!=='export'&&item.event!=='exportIn'"
                   :style="item.style"
                   :loading="item.loading"
                   size="small"
                   class="headerBtn"
                   v-show="item.show != null?item.show:true"
                   @click="handClick(item.event)"
                   :disabled="item.disabled">
          <span :class="item.icon" >{{item.desc}}</span>
        </el-button>
        <!-- 导出excel插件 -->
        <download-excel v-else-if="item.event=='export'"
                        style="display:inline-block"
                        :data="buttonList.exportInfo.json_data"
                        :fields="buttonList.exportInfo.json_fields"
                        :name="buttonList.exportInfo.name">
          <el-button :style="item.style"
                   :loading="item.loading"
                     size="small"
                     @click="handClick(item.event)"
                     :disabled="item.disabled"><span :class="item.icon" >{{item.desc}}</span></el-button>
        </download-excel>
        <el-upload v-else-if="item.event=='exportIn'"
                   class="upload-demo"
                   :action="postUrl+item.postUrl"
                   :disabled="item.disabled"
                   :show-file-list="false"
                   :on-success="handleAvatarSuccess"
                   :http-request="myUpload">
          <el-button size="small"
                     :style="item.style"
                   :loading="item.loading"
                     type="primary"><i :class="item.icon">{{item.desc}}</i></el-button>
        </el-upload>
      </div>

    </div>
    <div class="right">
      <div v-for="(item,index) of buttonList.right"
           :key="index"
           style="display:inline-block">
        <el-button v-if="item.type=='button'"
                   :loading="item.loading"
                   size="small"
                   @click="handClick(item.event)">
          <i :class="item.icon"></i>
        </el-button>
        <el-button v-if="item.type=='buttontwo'"
                   :loading="item.loading"
                   :style="item.style"
                   size="small"
                   @click="handClick(item.event)"
                   :disabled="item.disabled">
          <i :class="item.icon">{{item.desc}}</i>
        </el-button>
        <el-dropdown v-if="item.type=='down'"
                     trigger="click"
                     :hide-on-click="false">
          <el-button>
            <i :class="item.icon"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="(item,index) of fieldList"
                              :key="item.value">
              <el-checkbox v-if="item.dropdown"
                           v-model="checkedList[index]"
                           :true-label="'true'"
                           :false-label="'false'"
                           @change="checkChange">{{item.label}}
              </el-checkbox>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/api/config'
import axios from 'axios'
import { localStorageGet } from "@/utils/localStorageGet";
export default {
  name: 'BoyoButton',
  props: {
    buttonList: Object,
    fieldList: Array
  },
  data () {
    return {
      postUrl: config.baseURL,
      // 右按钮
      checkedList: []
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      for (let i in this.fieldList) {
        this.checkedList.push('' + this.fieldList[i].show)
      }
    },
    myUpload (content) {
      console.log(content)
      axios({
        method: 'post',
        url: content.action,
        data: content.file,
        headers: {
          'Content-type': 'multipart/form-data',
          'Token':localStorageGet("token")
        }
      }).then(res => {
        console.log(res)
        if (res.data.code == 0) {
          this.$message({ message: res.data.msg, type: 'success' })
          content.onSuccess(res.data)
        } else {
          this.$message({ message: res.data.msg, type: 'error' })
        }
      })
    },
    handleAvatarSuccess (res, file, fileList) {
      this.$emit('on-success', res, file, fileList, this.value)
    },
    checkChange () {
      this.$emit('handClick', 'table-menu', this.checkedList)
    },
    handClick (event) {
      this.$emit('handClick', event)
    }
  }
}
</script>
<style lang="stylus" scoped>
.Boyo-button>>>.el-dropdown
  margin-left -6px
.headerBtn
  height 26px
</style>



// WEBPACK FOOTER //
// src/components/BoyoButton/index.vue